import gql from 'graphql-tag'

export const customerFragment = gql`
    fragment customerFragment on Customer{
        id
        name
        label
        street
        town
        state
        country
        zipcode
        primary_phone
        secondary_phone
        fax
        website
        email
        note
        internal_notes
        deleted_at
        use_contact_as_location
    }
`